import { render, staticRenderFns } from "./AboutAirveyEditions.vue?vue&type=template&id=4c32aa1b&scoped=true&"
import script from "./AboutAirveyEditions.vue?vue&type=script&lang=js&"
export * from "./AboutAirveyEditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c32aa1b",
  null
  
)

export default component.exports